module.exports = __webpack_public_path__ + "static/media/tot-background-layer-3.07fbe26f.png";